module.exports = __webpack_public_path__ + "img/profile-avatar.34e8dd81.png";